import { Component } from 'san';
import commonService from 'src/services/common.service';

export default class About extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        currentYear: number;
        version: string;
    } {
        return {
            isShow: false,
            currentYear: 0,
            version: ''
        };
    }

    show(currentYear: number) {
        this.data.set('isShow', true);
        this.data.set('currentYear', currentYear);
        this.getVersion();
    }

    cancel() {
        this.data.set('isShow', false);
    }

    getVersion() {
        commonService.getVersion().then(version => {
            this.data.set('version', version);
        });
    }

}
